import React from "react";
import { useTranslation } from "react-i18next";

import { LocationAlertType } from "../../../../../models/LocationAlert";
import { HookFormSelect } from "../../../../HookForm/Select";
import "./styles.scss";

export const TypeSelect = () => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`adminLocationAlertsPage.adminLocationAlertCreateModal.${key}`);

  const options = Object.values(LocationAlertType).map((type) => ({
    label: t(`fields.type.types.${type}`),
    value: type,
  }));

  return (
    <div className="type-select">
      <HookFormSelect
        label={t("fields.type.label")}
        name="type"
        options={options}
      />
    </div>
  );
};
